export const emailsTableColumns = [
  {
    title: "Correo ID",
    key: "id",
    dataIndex: "id",
    width: 110,
    sorter: (a, b) => a.id - b.id,
    sortDirections: ["descend"],
    slots: { customRender: "id" },
    fixed: "left",
  },
  {
    title: "Estado",
    key: "statusSent",
    dataIndex: "statusSent",
    width: 100,
    slots: { customRender: "statusSent" },
    fixed: "left",
  },
  {
    title: "Contacto",
    key: "contact",
    dataIndex: "contact",
    width: 230,
    slots: { customRender: "contact" },
    fixed: "left",
  },
  {
    title: "Gestionado por:",
    key: "managedBy",
    dataIndex: "managedBy",
    width: 230,
    slots: { customRender: "managedBy" },
  },
  {
    title: "Correo de envío",
    key: "email",
    dataIndex: "email",
    width: 200,
    slots: { customRender: "email" },
    info: "Correo utilizado para el envío. Puede corresponder a un \"Enviar como\" o al identificador de correo.",
  },
  {
    title: "Identificador",
    key: "identifier",
    dataIndex: "identifier",
    width: 200,
    slots: { customRender: "identifier" },
  },
  {
    title: "Alias identificador",
    key: "alias",
    dataIndex: "alias",
    width: 150,
    slots: { customRender: "alias" },
  },
  {
    title: "Ticket asociado",
    key: "ticket",
    dataIndex: "ticket",
    width: 100,
    slots: { customRender: "ticket" },
  },
  {
    title: "Etiqueta",
    key: "tags",
    dataIndex: "tags",
    width: 100,
    slots: { customRender: "tags" },
  },
  {
    title: "Tipo de interacción",
    key: "emailType",
    dataIndex: "emailType",
    width: 100,
    slots: { customRender: "emailType" },
  },
  {
    title: "Fecha de última interacción",
    key: "lastDateInteraction",
    dataIndex: "lastDateInteraction",
    width: 230,
    sorter: (a, b) => new Date(b.lastDateInteraction) - new Date(a.lastDateInteraction),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "lastDateInteraction" },
  },
  {
    title: "Fecha de creación",
    key: "createdAt",
    dataIndex: "createdAt",
    width: 180,
    sorter: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "createdAt" },
  },
  {
    title: "Empresa",
    key: "entity",
    dataIndex: "entity",
    width: 180,
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "entity" },
  },
  {
    title: "Campaña",
    key: "portfolio",
    dataIndex: "portfolio",
    width: 180,
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "portfolio" },
  },
  {
    title: "Estrategia",
    key: "strategy_name",
    dataIndex: "strategy_name",
    width: 180,
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "strategy_name" },
  },
  {
    title: "Secuencias",
    key: "sequence_name",
    dataIndex: "sequence_name",
    width: 180,
    sortDirections: ["descend", "ascend"],
    slots: { customRender: "sequence_name" },
  },
  {
    title: "Acciones",
    key: "actions",
    dataIndex: "actions",
    fixed: "right",
    width: 150,
    slots: { customRender: "actions" },
  },
  // {
  //   title: "Contacto",
  //   key: "contact",
  //   dataIndex: "contact",
  //   width: 230,
  //   slots: { customRender: "contact" },
  //   fixed: "left",
  // },
  // {
  //   title: "Gestionado por:",
  //   key: "managedBy",
  //   dataIndex: "managedBy",
  //   ellipsis: true,
  //   width: 190,
  //   slots: { customRender: "managedBy" },
  // },
  // {
  //   key: "channels",
  //   dataIndex: "channels",
  //   width: 140,
  //   slots: { customRender: "channels", title: "channels_title" },
  // },
  // {
  //   key: "identifyChannels",
  //   dataIndex: "identifyChannels",
  //   width: 200,
  //   slots: { customRender: "identifyChannels", title: "identifyChannels_title" },
  //   ellipsis: true,
  // },
  // {
  //   key: "callsContact",
  //   dataIndex: "callsContact",
  //   width: 200,
  //   slots: { customRender: "callsContact", title: "callsContact_title" },
  //   ellipsis: true,
  // },
  // {
  //   title: "Cola",
  //   key: "queue",
  //   dataIndex: "queue",
  //   width: 170,
  //   slots: { customRender: "queues" },
  //   ellipsis: true,
  // },
  // {
  //   title: "Etiquetas",
  //   key: "tags",
  //   dataIndex: "tags",
  //   width: 170,
  //   slots: { customRender: "tags" },
  // },
  // {
  //   title: "Tipo de interacción",
  //   key: "interaction_type",
  //   dataIndex: "interaction_type",
  //   width: 170,
  // },
  // {
  //   title: "Último tipo de contacto",
  //   key: "last_management_group",
  //   dataIndex: "last_management_group",
  //   width: 200,
  //   sorter: (a, b) => a.contact_type.localeCompare(b.contact_type),
  //   sortDirections: ["descend", "ascend"],
  //   slots: { customRender: "contactType" },
  // },
  // {
  //   title: "Fecha de última interacción",
  //   key: "last_interaction_date",
  //   dataIndex: "last_interaction_date",
  //   width: 230,
  //   sorter: (a, b) => new Date(b.last_interaction_date) - new Date(a.last_interaction_date),
  //   sortDirections: ["descend", "ascend"],
  //   slots: { customRender: "date" },
  // },
  // {
  //   title: "Fecha de creación",
  //   key: "created_at",
  //   dataIndex: "created_at",
  //   width: 180,
  //   sorter: (a, b) => new Date(b.created_at) - new Date(a.created_at),
  //   sortDirections: ["descend", "ascend"],
  //   slots: { customRender: "date" },
  // },
  // {
  //   title: "Empresa",
  //   key: "entity",
  //   dataIndex: "entity",
  //   width: 230,
  //   sorter: (a, b) => a.entity.localeCompare(b.entity),
  //   sortDirections: ["descend", "ascend"],
  //   slots: { customRender: "entity" },
  // },
  // {
  //   title: "Nombre de la Campaña",
  //   key: "portfolio",
  //   dataIndex: "portfolio",
  //   width: 230,
  //   sorter: (a, b) => a.portfolio.localeCompare(b.portfolio),
  //   sortDirections: ["descend", "ascend"],
  // },
];
